import gql from "graphql-tag";

export default gql`
  subscription providerScan {
    providerScan: providerScan {
      status
      log
    }
  }
`